module.exports = __webpack_public_path__ + "static/media/warehouse_dark.00754de8.svg";